var render = function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"122","height":"122","viewBox":"0 0 122 122"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#DE3C4B","fill-rule":"nonzero","d":"M0 0h122v122H0z"}}),_c('path',{attrs:{"stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M75.4 61.3l-28 19.5v-39z"}})])]) };
module.exports = { render: render };


//////////////////
// WEBPACK FOOTER
// ./assets/_img/icons/icon-play-box.svg
// module id = 363
// module chunks = 0